export default function TodayPaperManager() { return <div>ম্যাগাজিন</div>; }